import _ from "underts";
import { EmptyRdvCase } from "cadendar-shared";

const isEmpty = (rdv: unknown): rdv is EmptyRdvCase =>
  _.assertProp(rdv, "tag") && rdv.tag === "empty";

export { isEmpty };
